/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import cx from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import { messages } from './messages';

/**
 * A component to render a Phone icon -- color can be overridden as "fill" prop.
 * @param {integer} props.size scales the result to a size x size square, default 32
 * @param {Object} props the properties for this component
 * @returns {Object} the JSX for this component
 */

interface PhoneIconProps {
  className?: string;
  size?: number;
  [key: string]: any;
}

export const PhoneIcon = ({
  className,
  size = 32,
  ...others
}: PhoneIconProps) => {
  const { formatMessage: t } = useIntl();
  const pxSize = size + 'px';
  return (
    <svg
      className={cx('PhoneIcon', className)}
      viewBox="0 0 32 32"
      width={pxSize}
      height={pxSize}
      fillRule="nonzero"
      xmlns="http://www.w3.org/2000/svg"
      fill="#FFFFFF"
      {...others}>
      <title id="phone-title">{t(messages.phone)}</title>

      <path d="M1.5 29.1c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5S0 31.3 0 30.5s.7-1.4 1.5-1.4zM29.1 1.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5S31.3 0 30.5 0s-1.4.7-1.4 1.5zM0 23.3v2.9c3.2 0 5.8 2.6 5.8 5.8h2.9c0-4.8-3.9-8.7-8.7-8.7zm0-5.8v2.9c6.4 0 11.6 5.2 11.6 11.6h2.9C14.5 24 8 17.5 0 17.5zm0-5.9v2.9c9.6 0 17.5 7.8 17.5 17.5h2.9c0-11.2-9.2-20.4-20.4-20.4zm32-5.8c-3.2 0-5.8-2.6-5.8-5.8h-2.9c0 4.8 3.9 8.7 8.7 8.7V5.8zm0 5.8c-6.4 0-11.6-5.2-11.6-11.6h-2.9c0 8 6.5 14.5 14.5 14.5v-2.9zm0 5.9c-9.6 0-17.5-7.8-17.5-17.5h-2.9c0 11.2 9.1 20.4 20.4 20.4v-2.9z" />
    </svg>
  );
};
